import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { spreadDangerousChildren } from "../../../utils/spreadDangerousChildren";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var CellLeftSide = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var title = _ref.title,
    subtitle = _ref.subtitle,
    isReverse = _ref.isReverse,
    disabled = _ref.disabled,
    isFullWidth = _ref.isFullWidth,
    _ref$leftSubtitleColo = _ref.leftSubtitleColor,
    leftSubtitleColor = _ref$leftSubtitleColo === void 0 ? 'secondary' : _ref$leftSubtitleColo;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('cell-left-side', {
      'cell-left-side--reverse': isReverse,
      'cell-left-side--multi': title && subtitle,
      'cell-left-side--full': isFullWidth,
      'cell-left-side--disabled': disabled
    }),
    "data-t-id": "components-CellLeftSide"
  }, title && /*#__PURE__*/React.createElement("span", _extends({
    className: cn('cell-left-side__title', {
      'cell-left-side__title--disabled': disabled
    })
  }, spreadDangerousChildren(title))), subtitle && /*#__PURE__*/React.createElement("span", _extends({
    className: cn('cell-left-side__subtitle', (_cn = {}, _defineProperty(_cn, "cell-left-side__subtitle--".concat(leftSubtitleColor), leftSubtitleColor), _defineProperty(_cn, 'cell-left-side__subtitle--disabled', disabled), _defineProperty(_cn, 'cell-left-side__subtitle--reverse', isReverse), _cn))
  }, spreadDangerousChildren(subtitle))));
});